import React from 'react';

import {useCurrentUserQuery} from '@/api';

import {OutlinePrimaryLink} from '../components/OutlinePrimaryLink';

export const Footer: React.FC = () => {
  const {data} = useCurrentUserQuery({errorPolicy: 'ignore'});
  const isLoggedIn = !!data?.currentUser;

  return (
    <footer className="bg-footer-bg px-16 pb-4 pt-32 text-white">
      <div className="mx-auto max-w-[1000px]">
        {!isLoggedIn && (
          <div className="mb-16 ml-auto w-fit">
            <OutlinePrimaryLink href="/signup" variant="white" size="lg">
              無料で新規登録
            </OutlinePrimaryLink>
          </div>
        )}

        <div className="flex flex-col gap-y-20 lg:flex-row lg:gap-x-10">
          {/* ブランド：ロゴ枠 */}
          <div className="shrink-0 self-start border-2 border-white px-5 py-3">
            <img
              src="/assets/logo-no-border.png"
              alt="ACTION CENTER MIHARA"
              className="h-16 w-auto"
            />
          </div>

          {/* 住所・電話・SNS */}
          <div>
            <p className="text-2xl font-semibold">ACTION CENTER MIHARA</p>

            <p className="mt-2 text-sm">
              〒723-0014
              <br />
              広島県三原市城町1-12-5 エムセックビル1・2階
            </p>

            <p className="mt-2 text-sm">
              <i className="fas fa-phone mr-1 text-xs" aria-hidden="true" />
              0848-63-5584
              <span className="ml-1 text-xs">
                （受付時間 平日 9:00〜17:30）
              </span>
            </p>
            <p className="mt-1 text-xs">
              「ACミハラについて」と言っていただけるとスムーズです。
            </p>

            <div className="mt-5">
              <a
                href="https://www.facebook.com/ACMihara/"
                target="_blank"
                rel="noreferrer"
                className="hover:text-gray-400">
                <i
                  className="fab fa-facebook-square text-xl"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>

          {/* メインナビ（アイコン付き） */}
          <nav className="lg:ml-auto">
            <ul className="text-md space-y-5 font-semibold">
              <li>
                <a
                  href="/#events"
                  className="flex items-center gap-4 hover:text-gray-400">
                  <i className="fas fa-search text-lg" aria-hidden="true" />
                  イベントをさがす
                </a>
              </li>
              <li>
                <a
                  href="/mypage/events/new?eventType=event"
                  className="flex items-center gap-4 hover:text-gray-400">
                  <i
                    className="fas fa-plus-circle text-lg"
                    aria-hidden="true"
                  />
                  イベントをつくる
                </a>
              </li>
              <li>
                <a
                  href="/mypage/groups/new"
                  className="flex items-center gap-4 hover:text-gray-400">
                  <i
                    className="fas fa-plus-circle text-lg"
                    aria-hidden="true"
                  />
                  グループをつくる
                </a>
              </li>
              <li>
                <a
                  href="/mypage/events/new?eventType=place"
                  className="flex items-center gap-4 hover:text-gray-400">
                  <i className="fas fa-building text-lg" aria-hidden="true" />
                  スペースをかりる
                </a>
              </li>
            </ul>
          </nav>

          {/* サブナビ */}
          <nav className="mr-24 lg:ml-12">
            <ul className="space-y-4 text-sm text-gray-200">
              <li>
                <a href="/about" className="hover:text-gray-400">
                  ACミハラについて
                </a>
              </li>
              <li>
                <a href="/facility" className="hover:text-gray-400">
                  料金・施設
                </a>
              </li>
              <li>
                <a href="/company" className="hover:text-gray-400">
                  運営会社
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-gray-400">
                  利用規約
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-gray-400">
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a href="/trade" className="hover:text-gray-400">
                  特定商取引法に基づく表示
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-gray-400">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="flex items-end justify-between">
          <a
            href="http://www.msec.co.jp/"
            target="_blank"
            rel="noreferrer"
            className="text-xs hover:text-gray-400">
            © EMUSEC CO.,LTD
          </a>

          {/* ページトップへ戻るボタン */}
          <button
            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
            className="flex size-16 items-center justify-center rounded-full border-2 hover:bg-white hover:text-primary"
            aria-label="ページトップへ">
            <i className="fas fa-chevron-up" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};
